<template>
  <div
    :key="keyUpdate"
    class="colored-sticker fw-sticker"
    :class="sClass"
    :style="sStyle"
    :data-id="sticker.id"
    data-type="sticker"
    @click="clickSticker"
    @touchend="clickSticker"
  >
    <textarea
      v-show="displayTextarea"
      ref="textarea"
      v-model="sticker.text"
      @blur="blurTextarea"
      @input="textareaAutoSize"
    />
    <div v-show="!displayTextarea" ref="content" class="content">
      {{ sticker.text }}
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
// Utils
import { textareaAutoSize } from '@/utils/main';

export default {

  name: 'FwSticker',

  props: {
    sticker: {
      type: Object,
      required: true,
    },
    problem: {
      type: Object,
      required: true,
    },
    fwRoot: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      displayTextarea: false,
      stickerHandled: false,
      colors: ['yellow', 'fuschia', 'red', 'orange', 'green', 'blue'],
      isDragging: false,
      editable: true,
    };
  },

  computed: {
    sClass() {
      return this.colors[this.sticker.color || 0];
    },
    sStyle() {
      return {
        position: 'absolute',
        left: `${this.sticker.x}px`,
        top: `${this.sticker.y}px`,
        visibility: this.isDragging ? 'hidden' : undefined,
      };
    },
    rect() {
      return {
        x: this.sticker.x, y: this.sticker.y, width: this.sticker.width, height: this.sticker.height,
      };
    },
  },

  mounted() {
    this.initDragging();
  },

  beforeDestroy() {
    let inst = $(this.$el).draggable('instance');
    if (inst) {
      $(this.$el).draggable('destroy');
    }
    inst = $(this.$el).resizable('instance');
    if (inst) {
      $(this.$el).resizable('destroy');
    }
  },

  methods: {
    textareaAutoSize,
    /** Setup drag and drop for stickers */
    initDragging() {
      // Alow moving stickers around and editing them
      // Listen to drag (to move) and click (to edit)
      $(this.$el).draggable({
        distance: 20,
        addClasses: false,
        start: () => {
          this.isDragging = true;
          this.editable = false;
        },
        stop: (event, ui) => {
          this.isDragging = false;
          if (!this.stickerHandled) {
            this.stickerHandled = false;
            const parentRect = this.fwRoot.$refs.fwContent.getBoundingClientRect();
            const gpRect = this.fwRoot.$refs.mainWrapper.getBoundingClientRect();
            this.sticker.x = ui.position.left - (parentRect.left - gpRect.left);
            this.sticker.y = ui.position.top - (parentRect.top - gpRect.top);
            this.$nextTick(this.edit);
          }
          this.fwRoot.binDisplayed = false;
          setTimeout(() => { this.editable = true; }, 100);
        },
        helper: (e) => {
          const clone = $(e.currentTarget).clone();
          clone.addClass('ui-draggable-dragging');
          clone.css('width', `${this.$el.offsetWidth}px`);
          clone.css('height', `${this.$el.offsetHeight}px`);
          $(this.fwRoot.$refs.mainWrapper).append(clone);
          return clone;
        },
      });
    },
    clickSticker() {
      if (this.editable) {
        this.displayTextarea = true;
        this.$nextTick(() => {
          this.$refs.textarea.focus();
        });
      }
    },
    blurTextarea() {
      this.displayTextarea = false;
      this.edit();
    },
    edit() {
      const params = {
        id: this.sticker.id,
        problemId: this.problem.id,
        text: this.sticker.text,
        rect: this.rect,
        color: this.sticker.color,
      };
      this.$http.post('/server/stickers/set.php', params).then(() => {
        this.fwRoot.sendStickersSocketUpdate();
      });
    },
  },
};
</script>

<style lang="scss">
.fw-sticker {
  height: auto;

  min-height: 50px;

  .content, textarea {
    min-height: 50px;
    width: 200px;
    height: auto;
    padding: 0.4rem;
    font-weight: 600;
    line-height: 1.4em;
    color: #ffffff;
    background: transparent;
    box-sizing: border-box;
    border: none;
    display: block;
    resize: none;
  }

  .content {
    word-wrap: break-word;
    overflow: auto;
    white-space: pre-line;
  }
}
</style>
